import { ClientViewListRepresentationOutput } from '@coverright/data-access/types/enrollment';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { useNoteForm, withNoteForm } from '../../../features/note-form';
import { useManagerNoteForm, withManagerNoteForm } from '../../../features/manager-note-form';

interface NotesRowProps {
  client: ClientViewListRepresentationOutput,
}

export const NotesRow = ({client}: NotesRowProps) => {
  return <tr>
    <Box component={'td'} className={'notes'} colSpan={10}>
      <Stack alignItems={'flex-start'} pb={.5}>
        <NoteButton note={client.latestNote || ''} noteId={client.latestNoteId || ''} clientId={client.clientId} />
        <ManagerNoteButton note={client.managerNote || ''} clientId={client.clientId} />
      </Stack>
    </Box>
  </tr>
}

const ManagerNoteButton = withManagerNoteForm(({note, clientId}: {clientId: string, note: string}) => {
  const {open} = useManagerNoteForm();

  return <ButtonBase sx={{mt: .3}} onClick={() => open(clientId, note)}>
    <Stack sx={{flexDirection: 'row', alignItems: 'center', gap: 1, width: 'fit-content'}}>
      <Typography sx={{fontWeight: 500}} variant={'body2'}>Manager notes:</Typography>
      <Typography sx={{color: 'text.secondary'}} variant={'caption'}>
        {crop(note.replace(/<[^>]*>|&nbsp;/g, ' ') || '')}
      </Typography>
    </Stack>
  </ButtonBase>
})

const NoteButton = withNoteForm(({note, clientId, noteId}: {clientId: string, note: string, noteId: string}) => {
  const {open} = useNoteForm();

  return <ButtonBase sx={{mt: .3}} onClick={() => open(clientId, {note, id: noteId})}>
    <Stack sx={{flexDirection: 'row', alignItems: 'center', gap: 1, width: 'fit-content'}}>
      <Typography sx={{fontWeight: 500}} variant={'body2'}>Notes:</Typography>
      <Typography sx={{color: 'text.secondary'}} variant={'caption'}>{crop(note || '')}</Typography>
    </Stack>
  </ButtonBase>
})

const crop = (str: string, max = 20) => {
  const words = str.split(' ');

  if (words.length > max) {
    return words.slice(0, max).join(' ') + '...';
  }

  return str;
}
